import { render, staticRenderFns } from "./Songs.vue?vue&type=template&id=db0e31ec&"
import script from "./Songs.vue?vue&type=script&lang=js&"
export * from "./Songs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/eric/projects/musical/musical-admin-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db0e31ec')) {
      api.createRecord('db0e31ec', component.options)
    } else {
      api.reload('db0e31ec', component.options)
    }
    module.hot.accept("./Songs.vue?vue&type=template&id=db0e31ec&", function () {
      api.rerender('db0e31ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Songs.vue"
export default component.exports